import { __ } from '../i18n.js';
import Icon from './Icon.jsx';

export default function BackButton({ onClick, label }) {
  return (
    <button type="button" class="etm-back-btn" onClick={onClick}>
      <Icon name="arrow_back" size={20} />
      {label || __('Terug', 'etm')}
    </button>
  );
}
